export default __webpack_public_path__ + "static/media/scan_device_in_app.08d8632e.png";